import React from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../step-header';
import StepWrapper from './step-wrapper';
import CircularProgress from './tone-step/circular-progress-bar';

var ToneCalibrationPlayTestSoundStep = function ToneCalibrationPlayTestSoundStep(_ref) {
  var content = _ref.content,
      onNextClick = _ref.onNextClick;
  return /*#__PURE__*/React.createElement(StepWrapper, {
    backgroundImage: content.BackgroundImage,
    stepClassNames: "step--tone-calibration-play-test-sound"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__text"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    icon: content.StepHeaderIcon,
    header: content.StepHeaderTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: "tone-progress"
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    sqSize: 60,
    strokeWidth: 10,
    percentage: 33,
    showPercentage: true
  })), /*#__PURE__*/React.createElement("h1", {
    className: "step__title"
  }, content.Heading), /*#__PURE__*/React.createElement("p", {
    className: "step__body"
  }, content.Body)), /*#__PURE__*/React.createElement("div", {
    className: "step__buttons"
  }, /*#__PURE__*/React.createElement("button", {
    className: "step-button step-button--play like-orange-button-large",
    onClick: function onClick(e) {
      e.preventDefault();
      onNextClick();
    }
  }, content.NextButtonLabel)));
};

ToneCalibrationPlayTestSoundStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired
};
export default ToneCalibrationPlayTestSoundStep;